import styled from 'styled-components'

const User = styled.div`
  justify-self: end;
  display: flex;
  align-items: center;
  column-gap: 4px;
`

const UserImage = styled.img`
  width: 18px;
  height: 18px;
  border-radius: 50%;
`

export { User, UserImage }
